import Vue from 'vue';
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';

export function SerialModalController () {
    this.campaign = {};
    this.campaignGroup = '';
    this.isAmbassadorCat = false;
    this.tag = '';
    this.busModal = new Vue();

    //#region relate modal
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.redeemSuccessModal = null;
    this.successModal = null;
    this.errorModal = null;
    this.copySuccessToast = null;

    this.setAlertModal = function (alertModal) {
        this.alertModal = alertModal;
    };
    this.setConfirmModal = function (confirmModal) {
        this.confirmModal = confirmModal;
    };
    this.setLoadingModal = function (loadingModal) {
        this.loadingModal = loadingModal;
    };
    this.setRedeemSuccessModal = function (redeemSuccessModal) {
        this.redeemSuccessModal = redeemSuccessModal;
    };
    this.setSuccessModal = function (successModal) {
        this.successModal = successModal;
    };
    this.setErrorModal = function (errorModal) {
        this.errorModal = errorModal;
    };
    this.setCopySuccessToast = function (copySuccessToast) {
        this.copySuccessToast = copySuccessToast;
    };
    //#endregion relate modal

    //#region callback
    this.cbClose = new CallbackEvent();
    this.cbAction = new CallbackEvent();
    this.cbSerialExpired = new CallbackEvent();
    //#endregion callback

    //#region setter
    this.setCampaign = function (campaign) {
        this.campaign = campaign;
        return this;
    };
    this.setCampaignGroup = function (campaignGroup) {
        this.campaignGroup = campaignGroup;
        return this;
    };
    this.setIsAmbassadorCat = function (isAmbassadorCat) {
        this.isAmbassadorCat = isAmbassadorCat;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function () {
        this.campaign = {};
        this.campaignGroup = '';
        this.isAmbassadorCat = false;
        this.tag = {};
        this.cbAction.clearCallback();
        this.cbClose.clearCallback();
        this.cbSerialExpired.clearCallback();
    };
    //#endregion setter

    //#region modal control
    this.show = function () {
        var config = {
            campaign: this.campaign,
            campaignGroup: this.campaignGroup,
            isAmbassadorCat: this.isAmbassadorCat,
            tag: this.tag
        };

        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion modal control
}
